/* global initNavigation */
(function ($) {

  $(function () {
    // dom ready | jQuery(document).ready
    initNavigation();
    initToggleMenu();
    // Image magnific-popup
    $('.blog-post').find('figure.blog-post-article-image, .gallery .gallery-item > div').children('a').magnificPopup(
      {
        type: 'image',
        gallery: {
          enabled: true
        },
        image: {
          titleSrc: function (item) {
            return  $(item.el).closest('figure').find('figcaption').text().length > 0 ? $(item.el).closest('figure').find('figcaption').text() : $(item.el).parent().next('figcaption').text();
          }
        }
      });

    // activate bootstrap validator
    $('#commentform').validator();

    //equal height for publications panel
    jQuery('.publication.panel').matchHeight({});

    //equal height for author-list
    jQuery('.author-list .col-md-6').matchHeight({});
  });

  $(window).resize(function () {
    //resize narando player according to main content size
    $(".narando-player, .narando-player > iframe").width($(".blog-container").width());
  });

  //Show the mobile link for the whatsapp share button if on mobile phone (not tablet)
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    jQuery('.whatsAppDesktop').hide();
    jQuery('.whatsAppMobile').show();
  }

  $('.gallery').each(function () {
    $(this)
      .clone()
      .removeClass('gallery')
      .addClass('gallery-nav')
      .insertAfter($(this));
  });

  $('.gallery-nav a').removeAttr('href');


  $('.gallery').each(function (key, item) {

    var sliderIdName = 'gallery' + key;
    var sliderNavIdName = 'gallery-nav' + key;

    this.id = sliderIdName;
    $('.gallery-nav')[key].id = sliderNavIdName;

    var sliderId = '#' + sliderIdName;
    var sliderNavId = '#' + sliderNavIdName;

    $(sliderId).slick({
      //dots: true,
      arrows: false,
      adaptiveHeight: true,
      lazyLoad: 'ondemand',
      asNavFor: sliderNavId,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            dots: true,
            arrows: true
          }
        }
      ]
    });

    $(sliderNavId).slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: sliderId,
      dots: true,
      centerMode: true,
      centerPadding: '60px',
      focusOnSelect: true,
      infinite: true,
      responsive: [
        {
          breakpoint: 1025,
        },
        {
          breakpoint: 768,
        },
        {
          breakpoint: 601,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          //settings: "unslick"
        }
      ]
    });
  });

})(jQuery);
